import type { FaireProductEntity } from "../../entity_types/product";

export const p_wdbadfh7jt: FaireProductEntity = {
  token: "p_wdbadfh7jt",
  type: "product",
  name: "Double Cross 18K Gold Plated S.Steel Huggie Earrings - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/59985756aa55e28ae8806ba49a2329fa743de7d025bb3599aaf7132a22322cab.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0f9d9f162180d9be53fa0696d3b2f8b7cca99579a81f030d1504c5b2eb63944e.jpeg",
    "https://cdn.faire.com/fastly/a97870ab456650b7f69711f111422bb7f7530a379359ffaeb1be87fbdb194ea0.jpeg",
    "https://cdn.faire.com/fastly/2b7ab7aa8045eca95b8a352d3b7b63efefea8e1883d1c84549238446f24e8316.jpeg",
  ],
  priceDollars: 7.52,
  description:
    "\nType: Earrings\nMaterial : Stainless steel ,18K gold plated\nSize :13mm*42mm\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts ",
  tags: [],
  msrpDollars: 18.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:01.206Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
